import React from 'react'

const SvgPerson = props => (
  <svg {...props} viewBox='0 0 199.35 208.26'>
    <g>
      <g id='Layer_1'>
        <g id='Layer_1-2' data-name='Layer_1'>
          <circle cx='99.38' cy='105.65' r='92.42' fill={'none'} stroke='#000' strokeMiterlimit={'10'} strokeWidth={3} />
          <g>
            <path d='M46.61,90v8.87h11.13v-8.87h3.5v21.7h-3.5v-9.49h-11.13v9.49h-3.5v-21.7h3.5Z' />
            <path d='M68.28,109.72c-1.52-1.52-2.33-3.75-2.33-6.51v-13.21h3.5v12.9c0,2.14.43,3.6,1.36,4.56.93.9,2.36,1.27,4.25,1.27s3.07-.43,3.91-1.24c.93-.93,1.33-2.42,1.33-4.59v-12.9h3.5v13.21c0,2.82-.81,5.02-2.29,6.54-1.55,1.52-3.78,2.33-6.64,2.33s-5.08-.84-6.6-2.36h.01Z' />
            <path d='M110.07,111.71h-3.41v-9.08l.12-7.35-5.71,10.48h-3.5l-5.74-10.42.09,7.29v9.08h-3.41v-21.7h4.12l6.67,12.15,6.7-12.15h4.06v21.7h0Z' />
            <path d='M125.07,90l8.31,21.7h-3.72l-2.08-5.52h-9.52l-2.05,5.52h-3.72l8.31-21.7h4.47ZM122.84,93.44l-3.5,9.4h7.01l-3.5-9.4h-.01Z' />
            <path d='M153.65,111.71h-3.81l-10.88-16.31.06,7.22v9.08h-3.41v-21.7h3.81l10.91,16.34-.09-7.25v-9.08h3.41v21.7h0Z' />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default SvgPerson



// WEBPACK FOOTER //
// ./components/icons/diagram/Person.js